import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取提现对账列表
   */
  getList(
    MaxResultCount: number,
    currentPage: number,
    TradeNo?: string,
    UpperAmount?: number,
    LowAmount?: number,
    CheckStatus?: number
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      TradeNo,
      UpperAmount,
      LowAmount,
      CheckStatus
    }
    return Ajax.get(`/api/distribution/WithdrawLogs`, {
      params: params
    })
  },
  /**
   * 审核对账
   * @param id
   * @param data
   */
  updateCheckStatus(data: {
    ids: string[]
    checkStatus: number
    remark: string
  }) {
    return Ajax.put(`/api/distribution/WithdrawLogs`, data)
  }
}
